import { settings } from './ajax-cart-utils';

export class AjaxCart {
  constructor() {
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.getCart = this.getCart.bind(this);
    this.updateCounter = this.updateCounter.bind(this);
    this.add = this.add.bind(this);
    this.getItemsCount = this.getItemsCount.bind(this);
    this.build = this.build.bind(this);
    this.buildCartModal = this.buildCartModal.bind(this);
    this.buildItem = this.buildItem.bind(this);
    this.appendCartModalHtml = this.appendCartModalHtml.bind(this);
    this.optimizeImageUrl = this.optimizeImageUrl.bind(this);

    this.settings = settings;

    $(document).on(
      'click',
      this.settings.selectors.cartClose,
      $.proxy(function(event) {
        event.preventDefault();

        this.close();
      }, this)
    );
  }

  /**
   * Get the cart and build it
   * @return {Void}
   */

  getCart(item) {
    $.ajax({
      url: '/cart?view=json',
      context: this,
      type: 'GET',
      dataType: 'json',
      success(cart) {
        this.build(cart, item);
      },
      error(err) {
        alert(err.responseJSON.description);
      },
    });
  }

  /**
   * Add item(s) to the cart and build it
   * @param {Array} items - An array holding the object(s) with item properties.
   *                      - More info: https://shopify.dev/docs/themes/ajax-api/reference/cart#post-cart-add-js
   * @return {Void}
   */

  add(items, $btn) {
    $.ajax({
      url: '/cart/add.js',
      context: this,
      type: 'POST',
      dataType: 'json',
      data: { items },
      success(item) {
        this.getCart(item);

        $(this.settings.selectors).removeClass(this.settings.actionClasses.btnLoading);

        $btn.addClass(this.settings.actionClasses.btnAdded)
      },
      error(err) {
        alert(err.responseJSON.description);
        $(this.settings.selectors).removeClass(this.settings.actionClasses.btnLoading);
      },
    });
  }

  /**
   * Build cart modal
   * @param  {Object}  cart       - The cart JSON
   * @param  {Object}  item       - Item JSON
   * @return {Void}
   */
  build(cart, item) {
    this.updateCounter(this.getItemsCount(cart));

    const template = this.settings.templates.cartModal;
    const itemHtml = this.buildItem(item.items[0]);

    this.buildCartModal(template, itemHtml);
  }

  /**
   * Build cart elements
   * @param  {String}  tempalte    - The cart modal template
   * @param  {String}  itemsHtml  - Item HTML
   * @return {Void}
   */

  buildCartModal(template, itemHtml = '') {
    const $holder = $(this.settings.selectors.cartModal);

    if (itemHtml !== '') {
      template = template.replace(/{{cartItem}}/g, itemHtml);
    }

    this.appendCartModalHtml($holder, template);
  }

  /**
   * Build cart modal item
   * @param  {Object}  item           - The cart modal item
   */

  buildItem(item) {
    let template = this.settings.templates.cartModalItem;
    const itemImageSize = this.settings.cartModal.itemImageSize;

    template = template.replace(
      /{{itemImageUrl}}/g,
      this.optimizeImageUrl(item.featured_image.url !== null ? item.featured_image.url : this.settings.noImage, itemImageSize)
    );
    template = template.replace(/{{itemImageAlt}}/g, item.featured_image.alt);
    template = template.replace(/{{itemTitle}}/g, item.product_title);
    template = template.replace(/{{itemSKU}}/g, item.sku);

    return template;
  }

  /**
   * Append item content to holder
   * @param  {jQuery Object} $holder - The holder to append items html to.
   * @param  {String} html - The item html.
   * @return {Void}
   */

  appendCartModalHtml($holder, html) {
    $holder[0].innerHTML = '';
    $holder[0].innerHTML = html;

    this.open();
  }

  /**
   * Optimize image based on parameter
   * @param  {String} url       - Image url
   * @param  {String} parameter - Size of the image, for example: '_200x200'
   * @return {String}           - Optimized image URL
   */

  optimizeImageUrl(url, parameter) {
    let imageUrl = url;
    let lastDotIndex = imageUrl.lastIndexOf('.');
    imageUrl = `${imageUrl.substring(0, lastDotIndex)}_${parameter}.${imageUrl.substring(lastDotIndex + 1)}`;

    return imageUrl;
  }

  /**
   * Update cart items counters
   * @param  {Integer} itemsCount - Items count
   * @return {Void}
   */

  updateCounter(itemsCount) {
    $(this.settings.selectors.cartCount)
      .toggleClass(this.settings.actionClasses.hidden, !itemsCount)
      .text(`${itemsCount}`);
  }

  /**
   * Get the cart items count
   * @param  {Object} cart - JSON of the cart
   * @return {Integer}     - Cart items count
   */

  getItemsCount(cart) {
    return cart.item_count;
  }

  /**
   * Opens the cart modal
   * @return {void}
   */

  open() {
    $(this.settings.selectors.cartModal).css('top', $(this.settings.selectors.header).find('.header__body').outerHeight())
      .addClass(this.settings.actionClasses.visible);
  }

  /**
   * Closes the cart modal
   * @return {void}
   */

  close() {
    $(this.settings.selectors.cartModal).removeClass(this.settings.actionClasses.visible);
  }
}

/**
 * Assign the Cart class to the window object for global use
 */

window.AjaxCart = new AjaxCart();
